// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24kNg","colMin":"styles_colMin__1OUGU"};